import LoyaltyAccountLandingPageYourBenefits from './LoyaltyAccountLandingPageYourBenefits'
import LoyaltyAccountLandingPageUserActivities from './LoyaltyAccountLandingPageUserActivities'
import LoyaltyWhatsNewCarousel from '../loyaltyLandingPageSharedSections/LoyaltyWhatsNewCarousel'
import LoyaltyUpcomingEscapesBenefits from './LoyaltyUpcomingEscapesBenefits'
import StatusMatchChallengeCard from 'loyalty/pages/statusMatch/StatusMatchChallengeCard'
import { useAppSelector } from 'hooks/reduxHooks'
import getLoyaltyIsInfiniteAccountTier from 'loyalty/selectors/getLoyaltyIsInfiniteAccountTier'

function LoyaltyAccountBenefitsContent() {
  // Status match is a route to Société tiers, so it's irrelevant to Infinite members.
  const isInfiniteTier = useAppSelector(getLoyaltyIsInfiniteAccountTier)

  return <>
    {!isInfiniteTier && <StatusMatchChallengeCard />}
    <LoyaltyUpcomingEscapesBenefits />
    <LoyaltyAccountLandingPageYourBenefits />
    <LoyaltyWhatsNewCarousel />
    <LoyaltyAccountLandingPageUserActivities />
  </>
}

export default LoyaltyAccountBenefitsContent
